import { useNavigate } from 'react-router-dom'
import { useText } from '../context/TextContext'
import { Invoice } from '../models/shared/Invoice'
import DealModalSection from './DealModalSection'
import { calculateLineItemsTotal, formatCurrency } from '../utils/shared/priceCalculator'
import { Deal } from '../models/shared/Deal'
import InvoiceState from './InvoiceState'
import { useOrganization } from '../context/OrganizationContext'
import { PATHS } from '../utils/shared/constants'
import { formatDate } from '../utils/date'

interface Props {
    invoices: Invoice[]
    deal: Deal
    className?: string
}

export default function DealInvoiceSection({ invoices, deal }: Props) {
    const text = useText()
    const navigate = useNavigate()
    const { organization } = useOrganization()
    const currency = organization.settings?.currency ?? 'SEK'

    if (!invoices.length) {
        return null
    }

    const sortedInvoices = [...invoices].sort((a, b) => (b.createdAt?.getTime() || 0) - (a.createdAt?.getTime() || 0))

    return (
        <DealModalSection title={text.invoices} open>
            <div className="d-flex flex-column gap-2">
                {sortedInvoices.map(invoice => {
                    const sums = calculateLineItemsTotal(invoice.lineItems || [])
                    return (
                        <div
                            key={invoice.id}
                            className="d-flex justify-content-between align-items-center pointer"
                            role="button"
                            onClick={() => navigate(`${PATHS.DEALS}/${deal.id}${PATHS.INVOICES}/${invoice.id}`)}
                        >
                            <small className="text-muted">
                                {invoice.invoiceNumber ? `#${invoice.invoiceNumber}` : formatDate(invoice.createdAt, { noTime: true })} — <InvoiceState invoice={invoice} />
                            </small>
                            <div className="fw-bold">{formatCurrency(sums.totalWithVat, currency)}</div>
                        </div>
                    )
                })}
            </div>
        </DealModalSection>
    )
}
